import { styled } from "styled-components";

export const AnchorLinksSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 96px 24px 48px 24px;
`;

export const AnchorLinksSectionContainer = styled.div`
  display: flex;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  align-self: stretch;
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const LinkCard = styled.div`
  display: flex;
  width: 235px;
  height: 235px;
  padding: 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
  cursor: pointer;
  overflow: clip;
  h4 {
    overflow-wrap: break-word;
    max-width: 100%;
  }
`;

export const IconSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;
